import * as Sentry from "@sentry/react";
import { FieldsType } from "./types";
import { Attachment } from "@sentry/core";
import { RcFile } from "antd/lib/upload";
import { fileToUint8Array } from "../utils/rc-file-to-uint8-array";

export function useFeedback({ afterSubmit }: { afterSubmit?: () => void }) {
  const send = async ({ message, attachments, screenshot }: FieldsType) => {
    const sentryAttachments: Attachment[] = [];

    for (const attachment of attachments?.fileList ?? []) {
      const data = await fileToUint8Array(attachment.originFileObj as RcFile);

      sentryAttachments.push({
        data,
        filename: attachment.name ?? "",
        contentType: attachment.type ?? "",
        attachmentType: "event.attachment",
      });
    }

    if (screenshot) {
      sentryAttachments.push({
        data: dataUrlToUint8Array(screenshot),
        filename: "screenshot.png",
        contentType: "image/png",
        attachmentType: "event.attachment",
      });
    }

    try {
      await Sentry.captureFeedback(
        {
          message,
          url: window.location.href,
        },
        {
          includeReplay: true,
          attachments: sentryAttachments,
        },
      );
    } catch (e) {
      console.error(e);
    }

    afterSubmit?.();
  };
  return {
    send,
  };
}

export function dataUrlToUint8Array(dataUrl: string): Uint8Array {
  const base64 = dataUrl.split(",")[1]; // Remove the data URL prefix
  const binaryString = atob(base64);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes;
}
